import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, AlertCircle, ArrowRight } from "lucide-react";
import { useI18n, useLocalizedPath } from "../i18n/I18nContext";

const COPY = {
  en: {
    okTitle: "You're unsubscribed.",
    okSub: "You won't receive any more emails in the Life Plot drip. Your account (if you have one) is untouched.",
    invalidTitle: "We couldn't find that link.",
    invalidSub: "It may have already been used or may be malformed. If this seems wrong, write to us.",
    backHome: "Back to home",
    contact: "Contact us",
  },
  ro: {
    okTitle: "Te-ai dezabonat.",
    okSub: "Nu vei mai primi alte emailuri din seria Life Plot. Contul tău (dacă ai unul) rămâne neschimbat.",
    invalidTitle: "Nu am găsit linkul.",
    invalidSub: "Este posibil să fi fost deja folosit sau să fie incorect. Dacă pare greșit, scrie-ne.",
    backHome: "Înapoi acasă",
    contact: "Scrie-ne",
  },
};

export default function Unsubscribed() {
  const { lang } = useI18n();
  const lp = useLocalizedPath();
  const [params] = useSearchParams();
  const status = params.get("status");
  const c = COPY[lang] || COPY.en;
  const invalid = status === "invalid";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="glass rounded-3xl p-10 md:p-14 w-full max-w-xl text-center"
      >
        <div className="mx-auto h-14 w-14 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center">
          {invalid ? (
            <AlertCircle className="h-7 w-7 text-gold" strokeWidth={1.75} />
          ) : (
            <CheckCircle2 className="h-7 w-7 text-gold" strokeWidth={1.75} />
          )}
        </div>
        <h1
          data-testid={invalid ? "unsub-invalid" : "unsub-ok"}
          className="mt-8 font-display text-section tracking-tight leading-[1.05]"
        >
          {invalid ? c.invalidTitle : c.okTitle}
        </h1>
        <p className="mt-5 text-cream-muted">{invalid ? c.invalidSub : c.okSub}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link to={lp("/")} className="btn btn-gold">
            {c.backHome} <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to={lp("/contact")} className="btn btn-ghost">
            {c.contact}
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
